const getStyleProp = (value) => {
  return getComputedStyle(document.documentElement).getPropertyValue(value);
};

export default getStyleProp;
